import React from 'react';
import Layout from './layout';
import { Button } from 'react-bootstrap';

const ScenarioCoaches: React.FC = () => {
    return (
        <Layout>

            <div data-aos="fade-up" data-aos-duration="1000">
            
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-flex align-items-center justify-content-between">
                                    

                                    <div className="d-flex align-items-center gap-15">
                                    <h1 className="mb-0 text-xxl"> Recommended <span className="text-accent">Coaches</span></h1>
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-primary dropdown-toggle rate_checker" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Rate Calculator <i className="mdi mdi-chevron-down"></i></button>
                                                <div className="dropdown-menu">
                                                    <a className="dropdown-item" href="#">Polly Rate Checker</a>
                                                    <div className="dropdown-item multidropdown">Lender Price Rate Checker 
                                                        <ul>
                                                            <li>
                                                                <a href="#">275 BPS</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">200 BPS</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">0 BPS</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">Account</a>
                                                            </li>
                                                            <li>
                                                                <a href="#">Powered by <strong>Lender Price</strong></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    
                                                </div>
                                                
                                            </div>
                                    </div>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                                            <li className="breadcrumb-item active">Recommended Coaches</li>
                                        </ol>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                        <div className="row processorCard">
                            <div className="col-lg-3">
                                <div className="process_box box_01">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_1.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>Total</p>
                                        <h4>130</h4>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-lg-3">
                                <div className="process_box box_02">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_2.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>Online</p>
                                        <h4>84</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="process_box box_03">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_3.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>Favourite</p>
                                        <h4>4,335</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="process_box box_04">
                                    <div className="process_boxcircel">
                                        <img src="assets/images/processor/Layer_4.svg"/>
                                    </div>
                                    <div className="process_boxcright">
                                        <p>History</p>
                                        <h4>4,335</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="processor_bg">
                            <div className="processor_search">
                                <div className="processor_searcharea">
                                    <input type="text" className="form-control" placeholder="Search"/>
                                    <span className="search_icon"><img src="assets/images/processor/search.svg"/></span>
                                </div>
                                <div className="processor_filter">
                                    <a className="right-bar-toggle" href="#">Filter <img src="assets/images/processor/filter.svg"/></a>
                                </div>
                            </div>
                            <div className="processor_listing lender_list coaches_list">
                                <ul>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/8580703981091552414BradTatecopy.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Bradley Tate</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/1670466235285805208Untitled-1.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tammy McCrae-Coley</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/15931433217016297171.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tiffiney Maxwell</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/8580703981091552414BradTatecopy.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Bradley Tate</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/1670466235285805208Untitled-1.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tammy McCrae-Coley</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/15931433217016297171.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tiffiney Maxwell</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/8580703981091552414BradTatecopy.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Bradley Tate</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/1670466235285805208Untitled-1.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tammy McCrae-Coley</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/15931433217016297171.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tiffiney Maxwell</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/8580703981091552414BradTatecopy.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Bradley Tate</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/1670466235285805208Untitled-1.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tammy McCrae-Coley</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="processor_listtop">
                                            <div className="live_btn"><span></span> Live</div>
                                            <div className="like_dislike">
                                                <a href="javascript:void(0);"><img src="assets/images/processor/like.svg"/></a>
                                                <span className="like_txt">30</span>
                                                <a href="javascript:void(0);"><img src="assets/images/processor/dislike.svg"/></a>
                                                <span className="dislike_txt">0</span>
                                            </div>
                                        </div>
                                        <div className="processor_lisbottom">
                                            <div className="rocessor_listimgctrl">
                                                <div className="rocessor_listimg">
                                                    <img className=' w-100 h-100 object-fit-cover' src="https://www.loanofficersupport.com/assets/media/accounts/15931433217016297171.png"/>
                                                    <span className="online_circel"></span>
                                                </div>
                                                
                                            </div>
                                            <div className="rocessor_listright">
                                                <h4>Tiffiney Maxwell</h4>
                                                <div className="rating"><img src="assets/images/processor/rating.png"/> (4.5/10)</div>
                                                <div className='d-flex gap-2 mt-3'>
                                                    <div className="submit_filearea my-0">
                                                        <a href="javascript:void(0);" className="favorite_icon">favorite</a>
                                                    </div>
                                                    <div className='my-2 d-flex justify-content-end align-items-center gap-2'>
                                                        <Button variant="primary" size='sm' className='py-2'>Refer a Loan</Button>
                                                        <Button variant="secondary" size='sm' className='py-2'> → NEXA U Loan</Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                         
            </div>

        </Layout>
    );
};

export default ScenarioCoaches;